import { Main, Login, ForgotPassword, ChangePassword } from './components'
import TwoFactor from "@/app/domains/Auth/components/forms/TwoFactor";

const children = [
  {
    name: 'auth.twofactor',
    path: '/two-factor',
    component: TwoFactor,
    meta: {
      requiresAuth: false,
      title: '2 Fatores',
      permission: 'public',
      rule: 'public'
    }
  },
  {
    name: 'auth.login',
    path: '/',
    component: Login,
    meta: {
      requiresAuth: false,
      title: 'Entrar',
      permission: 'public',
      rule: 'public'
    }
  },
  {
    name: 'auth.forgotPassword',
    path: '/recuperar-senha',
    component: ForgotPassword,
    meta: {
      title: 'Esqueci minha Senha',
      rule: 'public',
      requiresAuth: false,
      permission: 'public'
    }
  },
  {
    name: 'auth.changePassword',
    path: '/mudar-senha',
    component: ChangePassword,
    meta: {
      title: 'Mudar a senha',
      rule: 'public',
      requiresAuth: false,
      permission: 'public'
    }
  },
]

export default [{
  children,
  path: '/',
  component: Main,
  redirect: { name: 'auth.login' },
  meta: {
    permission: 'public'
  }
}]
